import urls from "../../global/constants/UrlConstants";
import {
  getCallParams,
  getFileCallParams,
  makeCall,
} from "../../utils/service";

export const getRagAsk = async (
  question: string,
  args: any,
  sessionId?: string
) => {
  try {
    const url = sessionId ? `${urls.ragAskApi}/${sessionId}` : urls.ragAskApi;
    const callParams = await getCallParams("POST", { question, args });
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const ragUploadFile = async (formData: any) => {
  try {
    const callParams = await getFileCallParams(formData);
    const response = await makeCall(urls.ragUploadFileApi, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getDocuments = async (page: number, rowsPerPage: number) => {
  try {
    const url = `${urls.getDocuments}?limit=${rowsPerPage}&page=${page}`;
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getAllSessions = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.getSessions, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getSessionById = async (sessionId: string) => {
  try {
    const url = `${urls.getSessions}/${sessionId}`;
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteSessionById = async (sessionId: string) => {
  try {
    const url = `${urls.getSessions}/${sessionId}`;
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchDocumentPreview = async (
  documentId: string,
  page: number
) => {
  try {
    const url = `${urls.getDocuments}/${documentId}/${page}`;
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
